var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1273.3 2998.8c5.6484 135.91 63.617 264.38 161.78 358.55 98.164 94.172 228.93 146.75 364.96 146.75s266.79-52.578 364.96-146.75c98.164-94.168 156.13-222.64 161.78-358.55zm1195.4-2302c-87.641-88.102-191.83-158.01-306.59-205.7-114.75-47.695-237.8-72.238-362.07-72.219 50.426 0.046875 98.008-23.367 128.74-63.348s41.117-91.98 28.102-140.7-47.949-88.613-94.523-107.94c-46.578-19.332-99.492-15.898-143.18 9.2891s-73.172 69.262-79.781 119.25c-6.6094 49.992 10.41 100.21 46.051 135.89 30.434 30.344 71.617 47.438 114.59 47.559-166.05 0.44531-329.08 44.43-472.82 127.57-143.74 83.137-263.16 202.52-346.34 346.23-83.18 143.71-127.22 306.73-127.71 472.78v775.25h-0.26562c0.011719 16.215-5.0625 32.031-14.516 45.207l-347.04 483.05v174.66h2617.4v-174.66l-343.18-477.82c-12.109-14.004-18.734-31.926-18.645-50.438v-775.25c-0.082031-124.28-24.703-247.32-72.445-362.07-47.746-114.74-117.68-218.93-205.78-306.59z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c02288e72020d1d5e9a5e1f0981ff918.svg";
export { ForwardRef as ReactComponent };